// NATIVE

// INSTALLED

// CUSTOM
import { AxiosAdapter } from '../commons/adapters';
import { closeSessionGlobal } from '../commons/utils';

const http = new AxiosAdapter();

export const getSucursalesServices = async () => {
  try {
    return await http.get<any>('/v1/branch');
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('getSucursalesServices ', error);
  }
};

export const getSucursalesForSelectService = async () => {
  try {
    return await http.get<any>('/v1/branch/data-select-inputs');
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('getSucursalesForSelectService ', error);
  }
};

export const getSucursalDataSelectsService = async () => {
  try {
    return await http.get<any>('/v1/branch/data-create-form-inputs');
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('getSucursalDataSelectsService ', error);
  }
};

export const saveSucursalService = async (branch: object, setPercentajeCSucursal: any) => {
  try {
    return await http.post<any>('/v1/branch', branch, setPercentajeCSucursal);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('saveSucursalService ', error);
  }
};

export const editSucursalService = async (branch: object, setPercentajeCSucursal: any) => {
  try {
    return await http.put<any>('/v1/branch', branch);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('editSucursalService ', error);
  }
};

export const getSucursalDetailService = async (sucursalId: string, setPercentajeCCompany: any) => {
  try {
    return await http.get<any>(`/v1/branch/${sucursalId}`);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('getSucursalDetailService ', error);
  }
};

export const desactiveSucursalService = async (sucursalId: string) => {
  try {
    return await http.delete<any>(`/v1/branch/${sucursalId}`);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }

    console.log('desactiveSucursalService ', error);
  }
};

export const activeSucursalService = async (sucursalId: string) => {
  try {
    return await http.patch<any>(`/v1/branch/${sucursalId}`);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }

    console.log('activeSucursalService ', error);
  }
};

export const getSucursalesByPaginateService = async (page: number) => {
  try {
    return await http.get<any>(`/v1/branch?page=${page}&take=10`);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('getSucursalesByPaginateService ', error);
  }
};
